import { render, staticRenderFns } from "./PullRequest.vue?vue&type=template&id=ecb30b12&scoped=true"
import script from "./PullRequest.vue?vue&type=script&lang=js"
export * from "./PullRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb30b12",
  null
  
)

export default component.exports